import React, { useState } from "react";

export interface IClientData {
  custName: string;
  brandId: string;
  modelSeriesId: string;
  vin: string;
  groupId: string;
  serviceGroup: boolean;
  tariffName: string;
  optionName: string[];
  balanceEndDate: string;
  endDateTxt: string;
  color: number;
  plate: string;
  PIN: string;
  products: any[];
  //polis?
}

const Result: React.SFC<IClientData> = (props) => {

  const requestDate = new Date();

  return (
    <React.Fragment>
      <div className="form-row">
        <div className="form-group col-12">
          <label htmlFor="#input1"><b>VIN номер*</b></label>
          <div className='vin-result-text'>{props.vin}</div>
        </div>
        <div className="form-group col-12 col-md-6">
          <label htmlFor="#input2"><b>Марка авто</b></label>
          <div className='vin-result-text'>{props.brandId}</div>
        </div>
        <div className="form-group col-12 col-md-6">
          <label htmlFor="#input3"><b>Модель авто</b></label>
          <div className='vin-result-text'>{props.modelSeriesId}</div>
        </div>
        <div className="form-group col-12">
          <label htmlFor="#input4"><b>ФИО клиента*</b></label>
          <div className='vin-result-text'>{props.custName}</div>
        </div>
        <div className="form-group col-12">
          <label htmlFor="#input7"><b>Тариф + опции</b></label>
          <div className='vin-result-text'>{props.tariffName + props.optionName}</div>
        </div>
        <div className="form-group col-12 mb-3">
          <label htmlFor="#input4">
            <b>Предполагаемая дата окончания денежных средств</b>
          </label>
          <div className='vin-result-text'>{props.endDateTxt}</div>
        </div>
      </div>
      <span className="card__comment-span">Дата запроса {requestDate.toLocaleDateString()}</span>
    </React.Fragment>
  );
};

export default Result;
